export default __webpack_public_path__ + "static/media/checkbox-inactive.fd0a6b12.svg";